import { render, staticRenderFns } from "./PlaceholderTab.vue?vue&type=template&id=442c411b&scoped=true&"
import script from "./PlaceholderTab.vue?vue&type=script&lang=js&"
export * from "./PlaceholderTab.vue?vue&type=script&lang=js&"
import style0 from "./PlaceholderTab.vue?vue&type=style&index=0&id=442c411b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442c411b",
  null
  
)

export default component.exports